'use client';

import Image from 'next/image';

import { getDefaultImgAlt } from '@core/Components/HeycarImage/GetDefaultImgAlt';
import { HeycarImage } from '@core/Components/HeycarImage/HeycarImage';
import { heycarLoader } from '@core/Components/HeycarImage/HeycarLoader';
import { IMAGE_SIZES } from '@core/Constants/ImageCarousel.constants';
import type { Vehicle } from '@core/Entities/Vehicle/Vehicle.entity';
import type { VehicleImage } from '@core/Entities/Vehicle/VehicleImage.entity';
import { getImgLoader } from '@core/Utils/Image/GetImgLoader';
import { Image as Pic } from '@gds/Icons/Paths/Image';
import RacLogo from '@gds/RacBadge/rac.webp';

import styles from './HeroImage.module.css';

const IMAGE_SIZE = 70;

export const HeroImage = ({
  image,
  index,
  isRacApproved,
  totalImages,
  makeModelLabel,
  isInactive,
  preloadLimit,
}: {
  vehicle?: Vehicle;
  image: VehicleImage;
  index?: number;
  isRacApproved?: boolean;
  totalImages?: number;
  makeModelLabel: string;
  isInactive?: boolean;
  preloadLimit?: number;
}) => {
  if (!image) return null;

  const mainImgString = getDefaultImgAlt();
  const loader = getImgLoader(image, heycarLoader);
  const logoSrc = isRacApproved ? RacLogo : null;
  const logoAlt = isRacApproved ? 'rac approved logo' : '';

  return (
    <figure className={styles.wrpr}>
      <HeycarImage
        src={image?.url}
        alt={image?.altText || `${mainImgString} - ${makeModelLabel}`}
        className={styles.img}
        sizes={IMAGE_SIZES.small}
        loader={loader}
        forceVisible={(index ?? 100) <= 1}
        preload={preloadLimit ? (index ?? 100) < preloadLimit : true}
        isInactive={isInactive}
      />

      {logoSrc && (
        <aside className={styles.racBadge}>
          <Image src={logoSrc} width={IMAGE_SIZE} height={IMAGE_SIZE} alt={logoAlt} />
        </aside>
      )}

      {totalImages && (
        <aside className={styles.imgsNum}>
          <Pic />
          {totalImages}
        </aside>
      )}
    </figure>
  );
};
